import { emptyFragment, Typography } from '@execonline-inc/execonline-ui';
import { AlreadyTranslated, AlreadyTranslatedText } from '@execonline-inc/translations';
import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';

interface Props {
  value: Maybe<AlreadyTranslatedText>;
}

function PromotableExperienceTileTitle({ value }: Props) {
  return value
    .map((title) => (
      <Typography className="mb-4 sm:mb-8" variant="h5" tabIndex={0}>
        <AlreadyTranslated content={title} />
      </Typography>
    ))
    .getOrElse(emptyFragment);
}

export default observer(PromotableExperienceTileTitle);
